/**
 * Читает готовые разрешения активной компании для клиентских сценариев доступа.
 * Правила выдачи прав и проверка действий над записями остаются на backend.
 */
import { getUserData } from "@/utils/userUtils";

// Возвращает права активной компании по ресурсам или пустой объект, если профиль их не содержит.
export function getCurrentPermissions() {
  return getUserData().current_company_permissions || {};
}

// Возвращает готовое разрешение backend для действия ресурса; отсутствие действия означает запрет.
export function can(resource, action) {
  const permissions = getCurrentPermissions();
  const entry = permissions[resource];
  if (!entry) return false;
  return entry[action] === true;
}
